import { render, staticRenderFns } from "./performanceReport.vue?vue&type=template&id=147a1206&"
import script from "./performanceReport.vue?vue&type=script&lang=js&"
export * from "./performanceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports